module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('section', [_c('main', {
    staticClass: "conteudo-principal columns"
  }, [_c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns search buscar-solicitacoes no-print"
  }, [_c('div', {
    staticClass: "formulario"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media u-margem-esquerda-pequena"
  }, [_vm._v("\n              Selecione o projeto para inserir novo valor de aporte e visualizar os aportes já efetuados\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }],
    attrs: {
      "id": "projeto",
      "name": "projeto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto
      }
    }, [_vm._v("\n                    " + _vm._s(projeto.Nome) + "\n                  ")])
  }), 0)])])])])], 1)])]), _vm._v(" "), (_vm.projeto.Id != null) ? _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('section', [_c('div', {
    staticClass: "grade__linha informacoes-resultado-filtro no-print grade__linha_distribuir-horizontal-entre-elementos"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_9"
  }, [_c('h2', {
    staticClass: "titulo titulo_grande u-margem-inferior-media"
  }, [_vm._v("\n            " + _vm._s(this.obterNomeDoProjetoSelecionado()) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_3 u-texto-alinhado-a-direita"
  }, [(_vm.projeto) ? _c('router-link', {
    staticClass: "botao botao_cor-terciaria botao_medio",
    attrs: {
      "to": _vm.rotaCadastroAporte
    }
  }, [_c('span', [_vm._v("Inserir novo aporte")])]) : _vm._e()], 1)]), _vm._v(" "), _c('hr', {
    staticClass: "u-margem-inferior-media"
  }), _vm._v(" "), (_vm.projeto.Tipo === 'Projeto' && _vm.projeto.Aportes) ? _c('TabelaDeAportesDoProjeto', {
    attrs: {
      "aportes": _vm.projeto.Aportes
    }
  }) : _vm._e(), _vm._v(" "), (_vm.projeto.Tipo === 'McmvCidades' && _vm.projeto.AportesDoMcmvCidades) ? _c('TabelaDeAportesDoMcmvCidades', {
    attrs: {
      "aportes": _vm.projeto.AportesDoMcmvCidades
    }
  }) : _vm._e()], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f64a5a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aportes/ListaDeAportes.vue
// module id = 1132
// module chunks = 1